import { VOCategory } from "../../model/DataStructure.js";
import { AbstractContentView } from "./AbstractContentView.js";

export class MediaGalleryContentView extends AbstractContentView {

    private _list: HTMLDivElement;
    private _category: VOCategory;

    constructor() {
        super();

        this.element.classList.add("video-gallery-content-view");
        this.element.innerHTML = `<div class="video-list active scrollbar vert"></div>`;
        this._list = this.element.querySelector(".video-list");

        $(this._list).on("click", "[data-galleryindex][data-mediaindex]", (e) => {
            var galleryIndex = parseInt(e.currentTarget.getAttribute("data-galleryindex"));
            var mediaIndex = parseInt(e.currentTarget.getAttribute("data-mediaindex"));
            this.onRequestGallery.dispatch(this._category.galleries, galleryIndex, mediaIndex);
        });

        this.showArrows = {
            left: "none",
            right: "none",
            index: 0,
            total: 0
        };
    }

    public open(): void {
    }

    public async create(category: VOCategory): Promise<boolean> {
        if (!category)
            return false;

        this._category = category;

        var html = "";
        for (var gallery of category.galleries.media) {
            for (var media of gallery.list_item_medias) {
                html += `
                <div class="video-list-item" data-galleryindex="${gallery.index}" data-mediaindex="${media.index}">
                    <div class="video-list-item-header" style="background-image: url(${media.sizes.medium})">
                        ${media.author ? `
                        <span class="video-list-item-publisher">${media.author}</span>
                        ` : ""}
                    </div>
                    <div class="video-list-item-body scrollbar">
                        <div class="video-list-item-title">${media.title}</div>
                        ${media.subtitle ? `
                        <div class="video-list-item-subtitle">${media.subtitle}</div>
                        ` : ""}
                        <div class="video-list-item-description">${media.description}</div>
                    </div>
                </div>`;
            }
        }
        this._list.innerHTML = html;

        return true;
    }

    public reset(): void {
        this._list.scrollTop = 0;
    }

    public handleClickClose(): boolean {
        return true;
    }
}